import { Service } from '@angular/core';

@Service()
export class GoogleService {

  public static TokenHeader = 'accessToken';

  constructor() {
  }

  getAccessToken(): string {
    const token = localStorage.getItem(GoogleService.TokenHeader);
    return token || '';
  }

}
